import { AnyAction } from 'redux';

import { DEFAULT_AUTO_COMPARE_LIMIT } from '@neptune/compare-domain';
import { getCurrentRoute, navigateTo } from '@neptune/shared/routing-business-logic';

import { NThunkAction } from 'state/types';

export function setAutoModeOn(autoCompareLimit?: number): NThunkAction<void, AnyAction> {
  return (dispatch, getState) => {
    const state = getState();
    const route = getCurrentRoute(state);

    dispatch(
      navigateTo(
        route.name,
        {
          ...route.params,
          compare: `auto-${autoCompareLimit || DEFAULT_AUTO_COMPARE_LIMIT}`,
        },
        { replace: true },
      ),
    );
  };
}

export function setShowOnlySelectedRuns(
  showOnlySelectedRuns: boolean,
): NThunkAction<void, AnyAction> {
  return setBooleanRouteParams({
    showOnlySelectedRuns: showOnlySelectedRuns ? showOnlySelectedRuns : undefined,
  });
}

function setBooleanRouteParams(
  params: Record<string, boolean | undefined>,
): NThunkAction<void, AnyAction> {
  return (dispatch, getState) => {
    const state = getState();
    const route = getCurrentRoute(state);

    dispatch(navigateTo(route.name, { ...route.params, ...params }, { replace: true }));
  };
}
